import NavigationLayout from "../navigation/navigationLayout";
import PolicyView from "./policyView";
import FooterLayout from '../footer/footerLayout';

const PolicyLayout = ({
    data
}) => {
    return (
        <>
            <NavigationLayout />

            <PolicyView data={data}/>

            <FooterLayout />
        </>
    );
}

export default PolicyLayout;